/**
 * ID of the "Vehicle condition" condition question.
 * @type {string}
 */
export const VEHICLE_CONDITION_CQ_ID = 'vehicle_condition';
